exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide {\r\n    display: none;\r\n}\r\n\r\n.show {\r\n    display: block;\r\n}\r\n\r\n.msg {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-manage-campaign/usc-manage-campaign.component.css
// module id = ../../../../../src/app/components/usc-store/usc-manage-campaign/usc-manage-campaign.component.css
// module chunks = main